import { useClearNotificationFlagsOnLeave } from '../../custom-hooks/useClearNotificationFlagsOnLeave';

export interface ClearNotificationFlagPrefixMatchesOnLeaveProps {
    eventCode: string;
}

export const ClearNotificationFlagPrefixMatchesOnLeave = (
    props: ClearNotificationFlagPrefixMatchesOnLeaveProps
): null => {
    useClearNotificationFlagsOnLeave(
        (eventCode) =>
            eventCode.toLowerCase().startsWith(props.eventCode.toLowerCase()),
        props.eventCode
    );
    return null;
};
